import React from 'react';
import { InputWrapper } from 'src/elements/forms/inputs/ProBooleanRadioInput.styles';
import { RequiredAsteriskWrapper, StyledLabel, RequiredHelpText } from './ProTextInput.styles';
import ProRadioInput from 'elements/forms/inputs/ProRadioInput';

interface ProMultipleChoiceInputProps {
  value: string;
  label: string;
  onSelect: (value: string) => void;
  options: string[];
  required?: boolean;
  inputName: string;
  submitted?: boolean;
}

const ProMultipleChoiceInput = (props: ProMultipleChoiceInputProps): JSX.Element => {
  return (
    <InputWrapper>
      <StyledLabel>
        {props.label}
        {props.required && <RequiredAsteriskWrapper>*</RequiredAsteriskWrapper>}
      </StyledLabel>

      {props.options.map(option => (
        <ProRadioInput key={option}
                       name={props.inputName}
                       checked={props.value === option}
                       value={option}
                       required={props.required}
                       onSelect={() => props.onSelect(option)}/>
      ))}
      {props.required && props.submitted && <RequiredHelpText>This field is required.</RequiredHelpText>}
    </InputWrapper>
  );
};

export default ProMultipleChoiceInput;
